import PhotoSwipeLightbox from "./photoswipe-lightbox.esm.min.js";

// Product options

document.querySelectorAll(".product-option-input").forEach(($option) => {
  $option.addEventListener("change", (e) => {
    const $form = $option.closest('form[action="/cart/add"]');
    const selectedOptions = [];

    const buttonLabel = $option
      .closest("div")
      .querySelector("button.product-option-button span");
    buttonLabel.textContent = e.target.value;

    $form.querySelectorAll(".product-option-input").forEach(($option2) => {
      if ($option2.type === "radio") {
        if ($option2.checked) {
          selectedOptions.push($option2.value);
        }
      } else {
        selectedOptions.push($option2.value);
      }
    });

    const selectedVariant = JSON.parse($form.dataset.variants).find(
      (variant) =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    );

    const $addToCartBtn = $form.querySelector(".btn-atc");
    const $addToCartBtnSticky = document.querySelector(
      "#product-sticky-atc #sticky-add-to-cart"
    );
    if (selectedVariant) {
      $form.querySelector('select[name="id"]').value = selectedVariant.id;

      if (selectedVariant.available) {
        $addToCartBtn.disabled = false;
        $addToCartBtn.querySelector("span").textContent =
          $addToCartBtn.dataset.textAddToCart;
        $addToCartBtnSticky.disabled = false;
      } else {
        $addToCartBtn.disabled = true;
        $addToCartBtn.querySelector("span").textContent =
          $addToCartBtn.dataset.textSoldOut;
        $addToCartBtnSticky.disabled = true;
        $addToCartBtnSticky.querySelector("span").textContent =
          $addToCartBtn.dataset.textSoldOut;
      }

      const productPriceContainer = $form
        .closest("#product-page")
        .querySelector(".product-price-container");
      const productPriceContainerSub = input
        .closest("#product-page")
        .querySelector(".product-price-container-sub");

      const productPriceFinal = productPriceContainer.querySelector(
        ".product-price-final"
      );
      const productPriceCompare = productPriceContainer.querySelector(
        ".product-price-compare"
      );

      const productPriceSubFinal = productPriceContainerSub.querySelector(
        ".product-price-final"
      );
      const productPriceSubCompare = productPriceContainerSub.querySelector(
        ".product-price-compare"
      );

      // eslint-disable-next-line no-template-curly-in-string
      const productPriceFormat = window.formatMoney(
        Number(selectedVariant.price),
        "${{amount_no_decimals}}"
      );
      const subPriceFormat = window.formatMoney(
        String(
          (Number(selectedVariant.price) *
            productPriceFinal.dataset.discountFactor) /
          100
        ),
        "${{amount}}"
      );

      productPriceFinal.textContent = productPriceFormat;
      productPriceSubFinal.textContent = subPriceFormat;

      const rechargeWidtet = document.querySelector(
        'input[name="recharge-widget-type"]:checked'
      );
      if (rechargeWidtet.value === "subscription") {
        productPriceFinal.textContent = subPriceFormat;
      } else {
        productPriceFinal.textContent = productPriceFormat;
      }

      if (selectedVariant.compare_at_price) {
        // eslint-disable-next-line no-template-curly-in-string
        productPriceCompare.textContent = window.formatMoney(
          selectedVariant.compare_at_price,
          "${{amount_no_decimals}}"
        );
        productPriceCompare.classList.remove("d-none");
      } else {
        productPriceCompare.classList.add("d-none");
      }

      window.history.replaceState(
        {},
        "",
        `${$form.dataset.productUrl}?variant=${selectedVariant.id}`
      );

      if (selectedVariant.featured_media) {
        bootstrap.Carousel.getInstance(
          $form.closest("#product-page").querySelector(".product-carousel")
        ).to(selectedVariant.featured_media.position - 1);
      }
    } else {
      $addToCartBtn.disabled = true;
      $addToCartBtn.querySelector("span").textContent =
        $addToCartBtn.dataset.textUnavailable;
      $addToCartBtnSticky.disabled = true;
      $addToCartBtnSticky.querySelector("span").textContent =
        $addToCartBtn.dataset.textUnavailable;
      window.history.replaceState({}, "", window.product.url);
    }
  });
});

// Product Media Gallery - Full Screen Gallery with PhotoSwipe
// https://photoswipe.com/v5/docs/getting-started/
const initProductMediaGallerySwipe = () => {
  document
    .querySelectorAll("#product-page .product-carousel")
    .forEach(($carousel) => {
      const lightbox = new PhotoSwipeLightbox({
        gallery: $carousel,
        children: "a.pswp-link",
        pswpModule: "./photoswipe.esm.min.js",
      });
      lightbox.init();
    });
};
initProductMediaGallerySwipe();

// Product Media Gallery - Sticky position on scroll (only in desktop)
const initProductMediaGallerySitcky = () => {
  document.querySelectorAll(".sticky-carousel").forEach(($carousel) => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 20) {
        const navbarHeight =
          document.querySelector("#shopify-section-navbar.sticky-top")
            .clientHeight || 0;
        $carousel.style.position = "sticky";
        $carousel.style.top = `${navbarHeight + 20}px`;
      }
    });
  });
};
initProductMediaGallerySitcky();

// Handle Ingredients
const handleIngredients = async () => {
  const $ingredientsBlock = document.querySelector(
    ".product-block-ingredients"
  );

  if ($ingredientsBlock) {
    const response = await fetch($ingredientsBlock.dataset.jsonFile);
    const data = await response.json();

    document.querySelectorAll("[data-ingredient-row]").forEach(($row) => {
      const ingredientData = data[$row.dataset.ingredientRow];

      if (ingredientData) {
        $row
          .querySelector("[data-ingredient-description]")
          .setAttribute("title", ingredientData.description);
        // eslint-disable-next-line no-new
        new bootstrap.Tooltip(
          $row.querySelector("[data-ingredient-description]"),
          {
            placement: "top",
          }
        );

        $row.querySelector("[data-ingredient-origin]").textContent =
          ingredientData.origin;
        $row.querySelector("[data-ingredient-score]").innerHTML = `
                    <span class="score-badge badge" style="background-color: ${ingredientData.score > 2 ? "#FF9E18" : "#019D4F"
          }">
                        ${ingredientData.score}
                    </span>
                `;
      }
    });
  }
};
handleIngredients();

// YotPo reviews on product page - small fixes
const $yotooMainWidget = document.querySelector(".yotpo.yotpo-main-widget");
if ($yotooMainWidget) {
  $yotooMainWidget.classList.add("container");
}

// If the page loads with reacharge schedule checked
document.addEventListener("DOMContentLoaded", function () {
  const rechargeSubscriptionEl = document.querySelector(
    "input#recharge-widget-type-subscription"
  );

  if (rechargeSubscriptionEl && rechargeSubscriptionEl.hasAttribute("checked")) {
    updateRechargeWidgetPrices(rechargeSubscriptionEl);
  }
});

function updateRechargeWidgetPrices(input) {
  const priceCompareEl = input
    .closest(`#product-page-container`)
    .querySelector(".product-price-compare");
  const oneTimePriceEl = input
    .closest(`#product-page-container`)
    .querySelector(".one-time-widget .product-price-final");
  const subscriptionPriceEl = input
    .closest(`#product-page-container`)
    .querySelector(".subscription-widget .product-price-final");

  const headerPriceCompare = document.querySelector(".product-header-price-compare");
  const headerFinalPrice = document.querySelector(".product-header-final-price");

  headerPriceCompare.textContent = priceCompareEl.textContent;

  if (input.value === "one-time") {
    document.querySelector(
      "#recharge-widget-schedule-list-wrapper"
    ).style.display = "none";
    document
      .querySelector(".subscription-widget")
      .classList.remove("active-recharge-widget");
    document
      .querySelector(".one-time-widget")
      .classList.add("active-recharge-widget");

    headerFinalPrice.textContent = oneTimePriceEl.textContent;
  } else {
    document.querySelector(
      "#recharge-widget-schedule-list-wrapper"
    ).style.display = "block";
    document
      .querySelector(".subscription-widget")
      .classList.add("active-recharge-widget");
    document
      .querySelector(".one-time-widget")
      .classList.remove("active-recharge-widget");

    headerFinalPrice.textContent = subscriptionPriceEl.textContent;
  }

  obRechargeSubscriptionChanged(input);
}

// Recharge widget
document.querySelectorAll('[name="recharge-widget-type"]').forEach((input) => {
  input.addEventListener("change", () => {
    updateRechargeWidgetPrices(input);
  });
});

//cart atribute uuid
try {
  const uuidInput = document.getElementById("pFormUUID");
  
  const ProductFormUUID = new Fingerprint({
    canvas: true,
    ie_activex: true,
    screen_resolution: true,
  });
  //check if input exists
  if (uuidInput) {
    uuidInput.value = ProductFormUUID.get();
  }
} catch (err) {
  console.error(err)
}

// Product form sampler dropdown (tag: mix-match-form)

document
  .querySelectorAll("#product-form-sampler-dropdown .variant-input")
  .forEach(async (input) => {
    const form = input.closest("form");

    const carousel = bootstrap.Carousel.getOrCreateInstance(
      form.closest("#product-page").querySelector(".product-carousel")
    );
    
    document
      .querySelectorAll("#product-form-sampler-dropdown .loading")
      .forEach((el) => {
        el.remove()
      })

    document
      .querySelectorAll("#product-form-sampler-dropdown .btn")
      .forEach((el) => {
        el.classList.remove('invisible')
      })
    
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    const variantValue = params.get("variant");

    if (variantValue === input.value) {
      carousel.to(Number(input.dataset.variantMediaPosition)-2);
    }

    input.addEventListener("change", (e) => {
      form.querySelector("button.dropdown-toggle span").textContent = input.dataset.variantTitle;

      if (input.dataset.productId == 7401235710127) {

        const variantsCarousels = document.querySelectorAll(`.product-carousel`)

        variantsCarousels.forEach((variantCarousel) => {
          const selectedVariant = `product-carousel-${input.dataset.productId}-${input.value}`;

          if (variantCarousel.id == selectedVariant) {
            variantCarousel.classList.remove('d-none')
          } else {
            variantCarousel.classList.add('d-none')

          }
        })

      } else {
        carousel.to(Number(input.dataset.variantMediaPosition) - 2); // consider the first image is for collection
      }

      const productPriceContainer = input
        .closest("#product-page")
        .querySelector(".product-price-container");

      const productPriceContainerSub = input
        .closest("#product-page")
        .querySelector(".product-price-container-sub");

      const productPriceFinal = productPriceContainer.querySelector(
        ".product-price-final"
      );

      const productPriceCompare = productPriceContainer.querySelector(
        ".product-price-compare"
      );

      const productPriceSubFinal = productPriceContainerSub.querySelector(
        ".product-price-final"
      );

      const productPriceSubCompare = productPriceContainerSub.querySelector(
        ".product-price-compare"
      );

      const productPriceFormat = window.formatMoney(
        Number(input.dataset.variantPrice),
        "${{amount_no_decimals}}"
      );

      const subPriceFormat = window.formatMoney(
        String(
          (Number(input.dataset.variantPrice) *
            productPriceSubFinal.dataset.discountFactor) /
          100
        ),
        "${{amount}}"
      );

      productPriceFinal.textContent = productPriceFormat;
      productPriceSubFinal.textContent = subPriceFormat;

      obUpdateRechargeWidgetSchedule(subPriceFormat);

      if (input.dataset.variantPriceCompare) {
        productPriceCompare.textContent = window.formatMoney(
          Number(input.dataset.variantPriceCompare),
          "${{amount_no_decimals}}"
        );
        productPriceSubCompare.textContent = window.formatMoney(
          Number(input.dataset.variantPriceCompare),
          "${{amount_no_decimals}}"
        );
      } else {
        productPriceSubCompare.textContent = window.formatMoney(
          Number(input.dataset.variantPrice),
          "${{amount_no_decimals}}"
        );
      }
      const addToBagContainer = input
        .closest("#product-page")
        .querySelector(".button-cart-container");
      const addToCartBtnSticky = document.querySelector(
        "#product-sticky-atc #sticky-add-to-cart"
      );

      if (input.dataset.variantAvailable == "false") {
        addToBagContainer.classList.add("d-none");
        addToCartBtnSticky.disabled = true;
      } else {
        addToBagContainer.classList.remove("d-none");
        addToCartBtnSticky.disabled = false;
      }

      window.history.replaceState(
        {},
        "",
        `${form.dataset.productUrl}?variant=${input.value}`
      );
      obPdpVariantChanged(input);
    });
  });

// Recharge widget schedule dropdown
document
  .querySelectorAll("#recharge-widget-schedule-dropdown .recharge-widget-input")
  .forEach((input) => {
    input.addEventListener("change", () => {
      const form = input.closest("form");
      form.querySelector(
        "button.recharge-widget-schedule-dropdown-toggle span"
      ).textContent = input.dataset.cartRechargePlanName;
    });
  });

/*
 * OpenBorder/PMall functions
 **/
function obRechargeSubscriptionChanged(input) {
  const finalPriceEl = input
    .closest("#product-page-content")
    .querySelector("[data-product-price]");

  obUpdatePriceOnSubChange(finalPriceEl, input);
}

function obPdpVariantChanged(input) {
  const headerId =
    screen.width > 991
      ? `product-form-header-desktop`
      : `product-form-header-mobile`;

  const productPriceContainer = input
    .closest("#product-page")
    .querySelector(`#${headerId}`)
    .querySelector(".product-price-container");
  const priceElement =
    productPriceContainer &&
    productPriceContainer.querySelector(".product-price-final");

  if (!priceElement) {
    return;
  }

  obUpdatePriceOnVariantSelect(priceElement, input);
  obUpdateRechargeWidgetVariant(input.value);

  if (input.dataset.variantPriceCompare) {
    const comparePriceElement = productPriceContainer.querySelector(
      ".product-price-compare"
    );
    obUpdatePriceOnVariantSelect(
      comparePriceElement,
      input,
      "variantPriceCompare"
    );
  }
}

function obUpdateRechargeWidgetVariant(variantId) {
  const variantAttribute = "data-pan-subscription-variant-id";
  const widgetClass = "recharge-widget-input";
  const rechargeElements = document.querySelectorAll(
    `.${widgetClass}[${variantAttribute}]`
  );

  rechargeElements.forEach((el) => {
    el.setAttribute(variantAttribute, variantId);
  });
}

function obUpdatePriceOnVariantSelect(
  priceElement,
  input,
  priceAtt = "variantPrice"
) {
  const variantId = input.value;
  const isCompare = priceAtt === "variantPriceCompare";

  const newElement = obUpdatePriceElement(
    priceElement,
    input,
    variantId,
    isCompare
  );

  return newElement;
}

function obUpdatePriceOnSubChange(
  priceElement,
  input,
  priceAtt = "productPrice"
) {
  const variantId = input.getAttribute("data-pan-subscription-variant-id");
  const isCompare = priceAtt === "variantPriceCompare";

  return obUpdatePriceElement(priceElement, input, variantId, isCompare);
}

function obUpdatePriceElement(priceElement, input, variantId, isCompare) {
  const attributesToRemove = ["data-amount", "data-currency"];
  const newPriceElement = priceElement.cloneNode();
  const originalTextContent = priceElement.textContent;

  attributesToRemove.forEach(
    newPriceElement.removeAttribute.bind(newPriceElement)
  );

  const priceInnerContainer = document.createElement("span");
  priceInnerContainer.textContent = originalTextContent;

  newPriceElement.setAttribute("data-product-variant-id", variantId);
  if (isCompare) {
    priceInnerContainer.textContent = window.formatMoney(
      Number(input.dataset.variantPriceCompare),
      "${{amount_no_decimals}}"
    );
    newPriceElement.setAttribute("data-price-variant", "compare-at");
  }

  priceInnerContainer.setAttribute("data-role", "price");
  newPriceElement.textContent = "";
  newPriceElement.appendChild(priceInnerContainer);

  priceElement.parentNode.insertBefore(newPriceElement, priceElement);
  priceElement.remove();

  return newPriceElement;
}

function obUpdateRechargeWidgetSchedule(subPrice) {
  const spanLabelRechargWidget = document.querySelector(
    "#recharge-widget-schedule-dropdown #recharge-widget-schedule-list .dropdown-label span"
  );

  spanLabelRechargWidget.textContent = subPrice;
}

const description = document.querySelectorAll(".product-block-description p");
description.forEach((val) => {
  if (val.innerHTML === "&nbsp;") {
    val.classList.add("d-none");
  }
});

$(document).ready(function () {
  function redirectToReviews() {
    const reviewsSection = document
      .getElementById("yotpo-reviews-main-widget")
      .closest(".shopify-section");
    const headerHeight = document.getElementById(
      "shopify-section-navbar"
    ).clientHeight;
    window.scrollTo({
      top: reviewsSection.offsetTop - headerHeight,
      behavior: "instant",
    });
  }

  $("#product-page .reviews-star").on("click", redirectToReviews);

  $("#product-sticky-atc-inner .reviews-star").on("click", redirectToReviews);
});
